import store from "@/store";
import axios from "axios";
import { Message } from "element-ui";
import util from "@/libs/util";
import router from "@/router";

// 创建一个错误
function errorCreate(msg) {
  const err = new Error(msg);
  errorLog(err);
  throw err;
}

// 记录和显示错误
function errorLog(err) {
  // 添加到日志
  store.dispatch("d2admin/log/add", {
    type: "error",
    err,
    info: "数据请求异常",
  });
  // 打印到控制台
  if (process.env.NODE_ENV === "development") {
    util.log.danger(">>>>>> Error >>>>>>");
    console.log(err);
  }
  // 显示Tips
  Message({
    message: err.message,
    type: "error",
    duration: 10 * 1000,
  });
}
console.log(process.env);
// 创建一个 axios 实例
const service = axios.create({
  // baseURL: "http://192.168.3.78:8088/",
  baseURL: process.env.VUE_APP_SERVERURL,
  headers: {
    "Content-Type": "application/json",
  },
  timeout: 1000 * 600, // 请求超时时间
});

// 请求拦截器
service.interceptors.request.use(
  (config) => {
    // 在请求发送之前做一些处理
    const token = util.cookies.get("token");
    var langtype = localStorage.getItem("lang") == "cn" ? 1 : "E";
    // 让每个请求携带token-- ['X-Token']为自定义key 请根据实际情况自行修改
    config.headers["token"] = config._token || token;
    delete config._token;
    if (config.url != "/common/uploadImage" && !config.upload) {
      if (config.method === "post") {
        //当需要直接传递原始的data时
        if(Array.isArray(config?.data?.data)){
          config.data = JSON.stringify(config.data);
        }else{
          if (!config.unConvert) {
            config.data = JSON.stringify({
              language: langtype,
              ...config.data,
            });
          }
        }
      } else if (config.method === "get") {
        config.params = {
          language: langtype,
          ...config.params,
        };
        // lineup 导出接口language 固定传E
        if (config.url === '/exportNewLineUpInfo'){
            config.params.language = 'E';
            console.log("75",config.params)
        }
      }
    }
    return config;
  },
  (error) => {
    // 发送失败
    console.log(error);
    Promise.reject(error);
  }
);

// 响应拦截器
service.interceptors.response.use(
  async (response) => {
    /**
     * 下面的注释为通过response自定义code来标示请求状态，当code返回如下情况为权限有问题，登出并返回到登录页
     * 如通过xmlhttprequest 状态码标识 逻辑可写在下面error中
     */
    let res = response.data;

    //导出，且数据格式正常
    if (response.config.responseType == "blob") {
      if (res.type != "application/json") {
        return res;
      } else {
        //将blob转成json
        res = await new Promise((resolve) => {
          const reader = new FileReader();
          reader.onload = function (e) {
            const res = JSON.parse(e.target.result);
            resolve(res);
          };
          reader.readAsText(res);
        });
      }
    }

    if (res.code != 10000) {
      Message({
        message: res.msg,
        type: res.code === 10001 ? 'warning':'error',
        duration: 5 * 1000,
      });
      if (res.code == 20000 || res.code == 10001) {
        return res;
      }
      // 当返回 JAM_DOES_NOT_SAVE_SECRETS 时，清除本地存储并退出到登录界面
      if ( res.msg ==='INVALID TOKEN') {
        // 删除 cookie 中的 token 和 uuid
        util.cookies.remove("token");
        util.cookies.remove("uuid");
        // 删除 localStorage 中的 uuid（如果存在）
        localStorage.removeItem("uuid");
          // 清除菜单权限信息
          store.commit("d2admin/router/setMenuList", []);
        // 跳转到登录页面
          router.push({
              name: "login",
          });
        return Promise.reject("error");
      }
      if (res.code === 40006) {
        history.go(0);
      }
      return Promise.reject("error");
    } else {
      return res;
    }
  },
  (error) => {
    if (error && error.response) {
      switch (error.response.status) {
        case 400:
          error.message = "请求错误";
          break;
        case 401:
          error.message = "未授权，请登录";
          break;
        case 403:
          error.message = "拒绝访问";
          break;
        case 404:
          error.message = `请求地址出错: ${error.response.config.url}`;
          break;
        case 408:
          error.message = "请求超时";
          break;
        case 500:
          error.message = "服务器内部错误";
          break;
        case 501:
          error.message = "服务未实现";
          break;
        case 502:
          error.message = "网关错误";
          break;
        case 503:
          error.message = "服务不可用";
          break;
        case 504:
          error.message = "网关超时";
          break;
        case 505:
          error.message = "HTTP版本不受支持";
          break;
        default:
          break;
      }
    }

      if (error.response.data) {
          try {
              if (error.response.data instanceof Blob) {
                  let reader = new FileReader();
                  reader.readAsText(error.response.data, 'utf-8');
                  reader.onload = () => {
                      Message({
                          message: JSON.parse(reader.result)?.message,
                          type: "error",
                          duration: 10 * 1000,
                      });
                  }
              } else {
                  Message({
                      message: error.response.data.message,
                      type: "error",
                      duration: 10 * 1000,
                  });
              }
          } catch (e) {
              errorLog(error)
          }
      } else {
          errorLog(error)
      }

    return Promise.reject(error);
  }
);

export default service;
